import { AnyAction, ListenerEffectAPI, ThunkDispatch } from '@reduxjs/toolkit';

import { AppRootState } from '../../../store/models/app-state.model';
import { getAppReleases } from '../thunks/get-app-releases.thunk';

export const AppsReleasesListenerEffect = (
  action: AnyAction,
  api: ListenerEffectAPI<
    AppRootState,
    ThunkDispatch<AppRootState, undefined, AnyAction>,
    unknown
  >
): void => {
  const appId = api.getState().appsFeature.releases.appId;

  const paginationParams = api.getState().appsFeature.releases.pagination;

  api.dispatch(
    getAppReleases({ entityId: appId, pagination: paginationParams })
  );
};
